import { createSelector } from 'reselect';
import {
  getAccounts,
  getTotalPortfolioBalance
} from 'state/account/AccountSelectors';
import { getUberId } from 'state/customer/CustomerSelectors';

export const getObservabilityMetadata = createSelector(
  getAccounts,
  getTotalPortfolioBalance,
  getUberId,
  (accounts, portfolioBalance, uberId) => {
    const products = new Set();
    let productString = '';
    const DELIMITER = ' ';
    if (accounts) {
      accounts.forEach((a) => products.add(a.productType));
      products.forEach((p) => (productString += p + DELIMITER));
    }
    return {
      accounts: accounts ? accounts.length : 0,
      products: productString,
      uberId,
      aum: portfolioBalance
    };
  }
);
